// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProposalYearProjectionOptionsQueryVariables = Types.Exact<{
  entityId: Types.Scalars['ID']['input'];
}>;


export type ProposalYearProjectionOptionsQuery = { __typename?: 'Query', proposalYearProjectionOptionsV2: Array<(
    { __typename?: 'YearProjectionOption' }
    & ProposalYearProjectionOptions_YearProjectionOptionFragment
  )> };

export type ProposalYearProjectionOptions_YearProjectionOptionFragment = { __typename?: 'YearProjectionOption', display: string, value: number };

export const Operations = {
  Query: {
    ProposalYearProjectionOptions: 'ProposalYearProjectionOptions' as const
  },
  Fragment: {
    ProposalYearProjectionOptions_YearProjectionOption: 'ProposalYearProjectionOptions_YearProjectionOption' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const ProposalYearProjectionOptions_YearProjectionOptionFragmentDoc = gql`
    fragment ProposalYearProjectionOptions_YearProjectionOption on YearProjectionOption {
  display
  value
}
    `;
export const ProposalYearProjectionOptionsDocument = gql`
    query ProposalYearProjectionOptions($entityId: ID!) {
  proposalYearProjectionOptionsV2(entityId: $entityId) {
    ...ProposalYearProjectionOptions_YearProjectionOption
  }
}
    ${ProposalYearProjectionOptions_YearProjectionOptionFragmentDoc}`;

/**
 * __useProposalYearProjectionOptionsQuery__
 *
 * To run a query within a React component, call `useProposalYearProjectionOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalYearProjectionOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalYearProjectionOptionsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useProposalYearProjectionOptionsQuery(baseOptions: Apollo.QueryHookOptions<ProposalYearProjectionOptionsQuery, ProposalYearProjectionOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProposalYearProjectionOptionsQuery, ProposalYearProjectionOptionsQueryVariables>(ProposalYearProjectionOptionsDocument, withFetchPolicyContext(options));
      }
export function useProposalYearProjectionOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProposalYearProjectionOptionsQuery, ProposalYearProjectionOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProposalYearProjectionOptionsQuery, ProposalYearProjectionOptionsQueryVariables>(ProposalYearProjectionOptionsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useProposalYearProjectionOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProposalYearProjectionOptionsQuery, ProposalYearProjectionOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProposalYearProjectionOptionsQuery, ProposalYearProjectionOptionsQueryVariables>(ProposalYearProjectionOptionsDocument, withFetchPolicyContext(options));
        }
export type ProposalYearProjectionOptionsQueryHookResult = ReturnType<typeof useProposalYearProjectionOptionsQuery>;
export type ProposalYearProjectionOptionsLazyQueryHookResult = ReturnType<typeof useProposalYearProjectionOptionsLazyQuery>;
export type ProposalYearProjectionOptionsSuspenseQueryHookResult = ReturnType<typeof useProposalYearProjectionOptionsSuspenseQuery>;
export type ProposalYearProjectionOptionsQueryResult = Apollo.QueryResult<ProposalYearProjectionOptionsQuery, ProposalYearProjectionOptionsQueryVariables>;